// Shared primitive types and enums used across all domain entities.
// Source of truth: Nsofar_DataCollection_by_Role_v1.docx + DRS v1.0
// ServiceType + ServiceCategory now live in service-type.ts (canonical
// home per ADR-015). Re-exported via index.ts so existing
// `import { ServiceType } from "@hcm/core"` paths keep working.
// DRS B1 visit_type (distinct from ServiceType — captures care intensity).
// Q9 D4 lock — `visit_type` is now also persisted on the SR model so the
// VisitReport wizard can branch its Clinical/Wellbeing reveal on it.
// Carer step-0 fallback applies when `SR.visit_type` is null at wizard mount.
export const VISIT_TYPES = [
    "standard_wellness",
    "extended_care",
    "companion",
    "post_discharge",
    "emergency_followup",
];
//# sourceMappingURL=common.js.map